import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import axios from 'axios'
import lrz from 'lrz'
import '@/plugins/element/element.js'
import '@/components/commonCss.css'
import {
  baseURL,

} from '@/config'
// import '@/assets/css/tailwindcss.css'
import qs from 'qs'
Vue.prototype.$qs = qs
// 环境切换配置
import proxyConfig from '@/conf/proxyConfig'
Vue.prototype.$proxyConfig = proxyConfig


Vue.prototype.$locationUrl = 'https://malls.aopiya.com/'
// Vue.prototype.$locationUrl = 'https://www.aopiya.com/'
Vue.prototype.$locationViewUrl = 'https://' + window.location.hostname + '/'
// Vue.prototype.$locationUrl = 'http://192.168.1.170:8099'
// Vue.prototype.$locationViewUrl = 'http://' + window.location.hostname + ':3002'
// Vue.prototype.$locationUrl='http://114.119.191.85:8099/'
// Vue.prototype.$locationUrl = 'https://www.aopiya.com/'
// 引入常用组件
import myPlugin from '@/components/index.js'
Vue.use(myPlugin)
import ResizeDirective from '@/utils/drog'
Vue.directive('resize', ResizeDirective);
//引入常用方法
//日期
import time from '@/utils/time_utils'
Vue.prototype.$time = time
//正则验证
import check from '@/utils/check_utils'
Vue.prototype.$check = check
//图片
import img_utils from '@/utils/img_utils'
Vue.prototype.$imgUtils = img_utils
//引入request
import axios from './http'
Vue.prototype.$axios = axios
import request from './utils/request'
Vue.prototype.$request = request
//过滤器加载
import { fullPath } from '@/utils/filters.js'
Vue.prototype.$fullPath = fullPath
Vue.filter('fullPath', fullPath)
//通用
Vue.prototype.$myGlobalMethod = function (url, type) {
  console.log('这是新的接口')
  if (store.getters['user/accessToken'] != localStorage.getItem('ACCESS-TOKEN')) {

    try {
      // 先调用后台方法验证两个token是否属于同一用户
      const params = {
        token: store.getters['user/accessToken'],
        token1: localStorage.getItem('ACCESS-TOKEN')
      };
      //  axios.get(baseURL + '/verifyIsSameUserToken', { params })//线下
      axios.get('https://' + window.location.hostname + '/api' + '/verifyIsSameUserToken', { params })//本地
        .then(response => {
          if (response.data.data == false) {

            router.push('/MallHomepage');
          } else {
            store.commit(
              "user/setAccessToken",
              localStorage.getItem('ACCESS-TOKEN')
            );
            window.open(url, type);
          }
        })
    } catch (error) {
      console.log('用户选择不保持当前登录状态或后台验证失败');
      store.commit(
        "user/setViewAccessToken",
        ''
      );
      router.push('/MallHomepage');
    }
    // 用户点击了"保持"，更新token


  } else {
    window.open(url, type);
  }

};
import common from '@/utils/common'
Vue.prototype.$common = common
document.addEventListener('touchstart', (event) => {
  if (event.touches.length > 1) {
    event.preventDefault();
  }
}, { passive: false });

document.addEventListener('wheel', (event) => {
  if (event.ctrlKey) {
    event.preventDefault();
  }
}, { passive: false });
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

Vue.config.productionTip = false

import moment from 'moment'	// 时间格式化
Vue.prototype.$moment = moment
Vue.prototype.$bus = new Vue();
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
